function Wishlist() {
    var self = this;

    this.$quickBasket = document.querySelector('.js-quick-wishlist');
    this.$quickBasketWrap = document.querySelector('.js-quick-wishlist__wrap');
    this.$count = document.querySelector(
        '.js-wishlist-count .header-action__count'
    );

    this.clearDuration = 300;
    this.clearDelay = 200;
    this.timeout = 6000;
    this.clear;

    this.storageKey = 'd3rwishlist';

    this.syncHeaderCount = function () {
        if (!this.$count) {
            return;
        }

        const count = Array.isArray(this.wishlist?.keys) ? this.wishlist.keys.length : 0;
        this.$count.innerHTML = count > 0 ? count : '';
    };

    this.init = () => {
        this.localStorageManager = new LocalStorageManager();

        // If user is identified, otherwise they won't have a wishlist for sure
        this.canHaveWishlist = document.cookie.indexOf('d3ri=') >= 0;

        const hadStoredWishlist = this.localStorageManager.has(this.storageKey);
        this.wishlist = hadStoredWishlist ? this.localStorageManager.get(this.storageKey, {}) : null;

        const tooOld = Date.now() - (6 * 60 * 60 * 1000);
        const lastUpdated = this.parseTimestamp(this.wishlist?.last_updated ?? this.wishlist?.updated ?? null);

        // the cache is tied to the identity it was built under, so a change of
        // identity (logging in or out) must invalidate the stale stored copy
        const identityChanged = hadStoredWishlist && (this.wishlist?.identified === true) !== this.canHaveWishlist;

        if (!this.wishlist || !Array.isArray(this.wishlist.keys)) {
            this.wishlist = {keys: [], item_lists: []};
        }

        if (!Array.isArray(this.wishlist.item_lists)) {
            this.wishlist.item_lists = [];
        }

        // always fetch the authoritative keys when nothing is stored (covers
        // first load and the delete-all flow which clears the key) or when the
        // identity changed, otherwise only re-sync stale data for identified
        // customers
        if (!hadStoredWishlist || identityChanged || (this.canHaveWishlist && (lastUpdated === null || lastUpdated < tooOld))) {
            this.refreshLocalWishlist();
        }

        this.syncHeaderCount();

        this.updateButtons();

        Soho.plugins.delegate(document, 'click', '.js-wishlist-add', (e) => this.addToWishlist(e));

        if (!document.documentElement.dataset.wishlistCountRefreshBound) {
            document.documentElement.dataset.wishlistCountRefreshBound = 'true';
            Soho.plugins.delegate(document, 'click', '.js-wishlist-count', () => {
                this.refreshStoredWishlist();
            });
        }

        const basketItems = document.querySelector('.basket-table tbody');

        if (this.canHaveWishlist && basketItems) {
            basketItems.addEventListener('click', (e) => {
                const link = e.target.closest('.js-wishlist-move-link');

                if (!link) {
                    return;
                }

                e.preventDefault();

                this.add(
                    link.href,
                    'GET',
                    new URLSearchParams(new FormData()).toString(),
                    link,
                    link.dataset.sku,
                    (response) => {
                        const data = response.payload;
                        if (!data) {
                            return;
                        }

                        const basketElem = document.querySelector('.basket');
                        const sidebar = document.querySelector('.basket-sidebar');
                        const subtotalMobileElement = basketElem.querySelector('.basket__main .basket-mobile-total');
                        const subtotalMobilePriceElement = subtotalMobileElement.querySelector('.basket-mobile-total__price');
                        const wishlistCount = document.querySelector('.js-wishlist-count .header-action__count');
                        const basketCount = document.querySelector('.js-basket-count .header-action__count');
                        const deliveryElement = sidebar.querySelector('.basket-delivery');

                        if (data.count) {
                            basket.items.content = data.html;
                            basket.items.dispatchEvent(new Event(Basket.Events.ITEM_REMOVED), data);
                        } else {
                            const basketTitle = document.querySelector('.basket__title');
                            const basketMembership = document.querySelector('.basket-membership');
                            const basketSidebar = document.querySelector('.basket__sidebar');
                            const basketPromo = document.querySelector('.basket__promo');

                            basketTitle.innerHTML = data.page_title;

                            const div = document.createElement("div");
                            div.innerHTML = data.empty_basket_html;
                            basketMembership.parentNode.replaceChild(div, basketMembership);

                            basketItems.parentElement.remove();
                            basketSidebar.remove();
                            basketPromo.remove();

                            if (window.dataLayer) {
                                Soho.GTM.trackRemoveBasketProducts([data.item], data.trackingCurrency);
                            }
                        }

                        if (data.count === 0) {
                            subtotalMobileElement.style.display = 'none';
                        } else {
                            subtotalMobilePriceElement.innerHTML = data.subtotal;
                        }

                        basketCount.innerHTML = data.count > 0 ? data.count : '';
                        wishlistCount.innerHTML = data.wishlist_count > 0 ? data.wishlist_count : '';
                        deliveryElement.innerHTML = data.delivery;
                    }
                );
            });
        }
    };

    this.updateButtons =  () => {
        document.querySelectorAll('.js-wishlist-add').forEach((button) => {
            const key = button.dataset.key;

            if (self.wishlist.keys && self.wishlist.keys.includes(key)) {
                this.setButtonAddedState(button);
                button.dataset.processed = 'true';
                return;
            }

            if (button.classList.contains('item-in-wishlist')) {
                this.setButtonDefaultState(button);
            }

            if (button.dataset.processed === 'true') {
                return;
            }

            button.dataset.processed = 'true';

            if (!this.canHaveWishlist) {
                const popup = new Popup(button);
                popup.init();

                Soho.popups.push(popup);
                return;
            }
        });
    }

    this.setButtonAddedState = function (button) {
        button.classList.add('item-in-wishlist');
        button.removeAttribute('disabled');

        const buttonText = button.querySelector('span');
        if (buttonText) {
            buttonText.innerText = 'Added to Wishlist';
        }
    }

    this.setButtonDefaultState = function (button) {
        button.classList.remove('item-in-wishlist');
        button.removeAttribute('disabled');

        const buttonText = button.querySelector('span');
        if (buttonText) {
            buttonText.innerText = 'Add to Wishlist';
        }
    }

    this.addToWishlist = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const button = e.target.closest('.js-wishlist-add');

        if (button) {
            if (button.classList.contains('item-in-wishlist')) {
                this.removeFromWishlist(button);
                return;
            }

            const key = button.dataset.key;
            const sku = button.dataset.sku;

            this.add(
                '/wishlist/add/' + key,
                'POST',
                '',
                button,
                sku
            );
        }
    }

    this.removeFromWishlist = (button) => {
        const key = button.dataset.key;
        const sku = button.dataset.sku;

        $.ajax({
            url: '/wishlist/remove/' + key,
            type: 'POST',
            success: (data) => {
                if (!data || !data.result) {
                    return;
                }

                const keyRemainsInWishlist = data.payload
                    && Array.isArray(data.payload.keys)
                    && data.payload.keys.includes(key);

                this.getPairedButtons(button).forEach((el) => {
                    if (keyRemainsInWishlist) {
                        this.setButtonAddedState(el);
                        return;
                    }

                    this.setButtonDefaultState(el);
                });

                if (data.payload && Array.isArray(data.payload.keys)) {
                    this.updateLocalStorage(data.payload.keys, data.payload.item_lists || []);
                } else {
                    this.removeKeyFromLocalStorage(key);
                }

                if (this.$count && data.payload && typeof data.payload.wishlist_count !== 'undefined') {
                    this.$count.innerHTML = data.payload.wishlist_count > 0 ? data.payload.wishlist_count : '';
                }

                this.trackEvent('Remove', sku, button);
            },
        });
    }

    this.pickListAndAdd = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const row = e.target.closest('.js-wishlist-pick-list');

        if (!row) {
            return;
        }

        const key = row.dataset.key;
        const keys = (row.dataset.keys || '')
            .split(',')
            .map((itemKey) => itemKey.trim())
            .filter(Boolean);
        const listUuid = row.dataset.listUuid;
        const button = self.pendingButton
            || (key ? document.querySelector('.js-wishlist-add[data-key="' + key + '"]') : null)
            || row;
        const sku = self.pendingSku || row.dataset.sku;

        const params = new URLSearchParams();
        params.set('list_uuid', listUuid);

        if (keys.length > 1) {
            keys.forEach((itemKey) => {
                params.append('sku[]', itemKey);
            });

            self.add('/wishlist/add', 'POST', params.toString(), button, sku);
            return;
        }

        self.add(
            '/wishlist/add/' + key,
            'POST',
            params.toString(),
            button,
            sku
        );
    }

    this.getPairedButtons = function(button) {
        const buttons = [button]

        if (button.classList.contains('product-detail__wishlist')) {
            const sticky = document.querySelector('.product-sticky-cta__wishlist');
            if (sticky) {
                buttons.push(sticky);
            }

        } else if (button.classList.contains('product-sticky-cta__wishlist')) {
            const normal = document.querySelector('.product-detail__wishlist');
            if (normal) {
                buttons.push(normal);
            }
        }

        return buttons
    }

    this.bindQuickWishlistContainer = function () {
        self.$container = self.$quickBasketWrap?.querySelector('.js-quick-wishlist__container');

        if (!self.$container) {
            return;
        }

        self.$close = self.$container.querySelector('.js-quick-wishlist__close');

        if (self.$close) {
            self.$close.onclick = self.closeQuickWishlist;
        }

        self.$quickBasket.onclick = self.deactivate.bind(self);

        self.$container.onclick = function (e) {
            if (e.target.closest('.js-quick-wishlist__close')) {
                self.closeQuickWishlist(e);
                return;
            }

            if (e.target.closest('.js-wishlist-pick-list')) {
                self.pickListAndAdd(e);
                return;
            }

            if (e.target.closest('.js-wishlist-new-list')) {
                self.openNewListForm(e);
                return;
            }

            if (e.target.closest('.js-quick-wishlist__change')) {
                e.preventDefault();
                e.stopPropagation();

                const popup = e.target.closest('.wishlist-added-popup');
                const added = popup?.querySelector('.js-quick-wishlist__added');
                const picker = popup?.querySelector('.js-quick-wishlist__picker');

                if (added && picker) {
                    added.hidden = true;
                    picker.hidden = false;
                }

                return;
            }

            e.stopPropagation();
        };

        self.$container.onsubmit = function (e) {
            if (e.target.closest('.js-wishlist-new-list-form')) {
                self.submitNewListForm(e);
            }
        };
    }

    this.escapeAttribute = function (value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    this.getPendingKeys = function (container) {
        const rawKeys = container?.dataset?.keys
            || self.pendingKeys?.join(',')
            || self.pendingButton?.dataset?.key
            || '';

        return rawKeys
            .split(',')
            .map((itemKey) => itemKey.trim())
            .filter(Boolean);
    }

    this.getNewListFormHtml = function (keys = []) {
        const hiddenInputs = keys.map((key) => (
            `<input type="hidden" name="sku[]" value="${self.escapeAttribute(key)}">`
        )).join('');

        return `
            <div class="wishlist-selector quick-wishlist__container js-quick-wishlist__container">
                <div class="wishlist-selector__header">
                    <span class="wishlist-selector__title">New Wishlist</span>
                    <a href="#" class="wishlist-selector__close js-quick-wishlist__close" aria-label="Close">
                        <svg class="icon icon-close" aria-hidden="true" focusable="false"><use href="#icon-close" xlink:href="#icon-close"></use></svg>
                    </a>
                </div>
                <form method="post" action="/wishlists/create" class="wishlist-selector__create-form js-wishlist-new-list-form">
                    ${hiddenInputs}
                    <label class="wishlist-selector__field" for="quick_wishlist_name">
                        <span class="wishlist-selector__field-label">List name</span>
                        <input id="quick_wishlist_name" maxlength="255" name="wishlist_name" class="wishlist-selector__field-input" type="text" value="" required>
                    </label>
                    <p class="wishlist-selector__error js-wishlist-new-list-error" hidden>
                        Unable to create list. Please try again.
                    </p>
                    <button type="submit" class="wishlist-selector__cta">
                        Create list
                    </button>
                </form>
            </div>
        `;
    }

    this.openNewListForm = function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        self.pendingKeys = self.getPendingKeys(e.target.closest('.wishlist-selector'));
        self.$quickBasketWrap.innerHTML = self.getNewListFormHtml(self.pendingKeys);
        self.bindQuickWishlistContainer();

        self.$container.querySelector('.wishlist-selector__field-input')?.focus();
    }

    this.addKeysToLocalStorage = function (keys, listUuid) {
        if (!Array.isArray(keys) || !keys.length) {
            return;
        }

        const existingKeys = this.wishlist && Array.isArray(this.wishlist.keys) ? this.wishlist.keys : [];
        const itemLists = this.wishlist && Array.isArray(this.wishlist.item_lists) ? [...this.wishlist.item_lists] : [];

        keys.forEach((key) => {
            if (!existingKeys.includes(key)) {
                existingKeys.push(key);
            }

            if (!listUuid) {
                return;
            }

            const itemList = itemLists.find((item) => item.key === key);
            if (itemList) {
                itemList.list_uuids = Array.isArray(itemList.list_uuids) ? itemList.list_uuids : [];
                if (!itemList.list_uuids.includes(listUuid)) {
                    itemList.list_uuids.push(listUuid);
                }
                return;
            }

            itemLists.push({
                key,
                list_uuids: [listUuid],
            });
        });

        this.updateLocalStorage(existingKeys, itemLists);
    }

    this.submitNewListForm = function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const form = e.target.closest('.js-wishlist-new-list-form');
        const submit = form.querySelector('[type="submit"]');
        const error = form.querySelector('.js-wishlist-new-list-error');

        if (submit) {
            submit.setAttribute('disabled', 'disabled');
        }

        if (error) {
            error.hidden = true;
        }

        fetch(form.action, {
            method: form.method.toUpperCase(),
            body: new FormData(form),
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to create wishlist');
                }

                return response.json();
            })
            .then((data) => {
                if (data.payload?.redirect) {
                    const redirect = new URL(data.payload.redirect, window.location.origin);
                    const listUuid = redirect.pathname.split('/').filter(Boolean).pop();
                    self.addKeysToLocalStorage(self.pendingKeys || [], listUuid);
                    window.location.href = data.payload.redirect;
                    return;
                }

                if (data.payload?.html) {
                    self.$quickBasketWrap.innerHTML = self.getNewListFormHtml(self.pendingKeys || []);
                    self.bindQuickWishlistContainer();
                    return;
                }

                throw new Error('Invalid create wishlist response');
            })
            .catch(() => {
                if (submit) {
                    submit.removeAttribute('disabled');
                }

                if (error) {
                    error.hidden = false;
                }
            });
    }

    this.closeQuickWishlist = function (e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        self.deactivate();
    }

    this.openLoggedOutPopup = function (button) {
        const itemKeyInput = document.querySelector('.popup--wishlist [name="key"]');
        if (itemKeyInput && button?.dataset?.key) {
            itemKeyInput.value = button.dataset.key;
        }

        if ($.magnificPopup) {
            $.magnificPopup.open({
                items: {
                    src: '.popup--wishlist',
                },
                type: 'inline',
                mainClass: 'mfp--light',
            });
            return;
        }

        window.location.href = '/account/login?redirect=/wishlists';
    }

    this.add = function (url, type, data, button, sku, onSuccess) {
        $.ajax({
            url: url,
            type: type,
            data: data,
            success: function (data) {
                if (!data.result) {
                    if (data.payload && data.payload.customer_logged_in === false) {
                        self.openLoggedOutPopup(button);
                    }
                    return;
                }

                // multi-list selector path: render the selector popup but
                // do not mark the item as added yet
                if (data.payload && data.payload.is_selector) {
                    self.$quickBasketWrap.innerHTML = data.payload.wishlist_notification;

                    self.bindQuickWishlistContainer();

                    self.activate();
                    self.pendingButton = button;
                    self.pendingSku = sku;
                    return;
                }

                // Check if there is a paired button and update each
                self.getPairedButtons(button).forEach((el) => {
                    self.setButtonAddedState(el);
                });

                if ('keys' in data.payload) {
                    self.updateLocalStorage(data.payload.keys, data.payload.item_lists || []);
                } else {
                    self.addKeyToLocalStorage(button?.dataset?.key);
                }

                // Update the quick basket and the basket count
                self.update(data.payload.wishlist_count);

                // Add the html to the quick basket
                self.$quickBasketWrap.innerHTML = data.payload.wishlist_notification;

                self.bindQuickWishlistContainer();

                self.trackEvent('Add', sku, button);

                if (typeof onSuccess === 'function') {
                    onSuccess(data);
                }
            },
        });
    };

    this.update = function (count) {
        this.activate();
        if (this.$count) {
            this.$count.innerHTML = count > 0 ? count : '';
        }
        this.clear = setTimeout(this.deactivate.bind(this), this.timeout);
    };

    this.activate = function () {
        this.$quickBasket.classList.add('quick-wishlist--activating');

        setTimeout(function () {
            self.$quickBasket.classList.add('quick-wishlist--active');
            // self.$close.focus();
        }, 200);
    };

    this.deactivate = function () {
        this.$quickBasket.classList.remove('quick-wishlist--active');
        setTimeout(function () {
            self.$quickBasket.classList.remove('quick-wishlist--activating');
            clearTimeout(self.clear);
        }, this.clearDuration + this.clearDelay);
    };

    /**
     * Track the interaction into GTM
     *
     * @param {String} action action taken
     * @param {String|Number} sku product SKU
     * @param {Element} button button clicked
     */
    this.trackEvent = function (action, sku, button) {
        const location = getButtonLocation(button)

        if (window.dataLayer) {
            dataLayer.push({
                'event': 'd3rEvent',
                'd3rEvent': {
                    'category': 'Wishlist',
                    'action': `${action} (${location})`.trim(),
                    'label': sku,
                },
            });
        }
    }

    /**
     * Try and derive a location - one of PDP, PLP, Carousel, or null - from the clicked element
     *
     * @param {Element} buttonElement
     */
    const getButtonLocation = (buttonElement) => {

        if (buttonElement.dataset.wishlistEventLocation) {
            return buttonElement.dataset.wishlistEventLocation;
        }

        const pdp = document.querySelector('.product-detail__right');

        if (pdp && pdp.contains(buttonElement)) {
            return 'PDP'
        }

        const plp = document.querySelector('.listing');

        if (plp && plp.contains(buttonElement)) {
            return 'PLP'
        }

        const carousels = document.querySelectorAll('.products-list');

        for (let i = 0; i < carousels.length; i++) {
            if (carousels[i].contains(buttonElement)) {
                return 'Carousel'
            }
        }

        return ''
    }

    this.parseTimestamp = function (value) {
        if (typeof value === 'number') {
            return value;
        }

        if (typeof value === 'string') {
            const parsed = Date.parse(value);
            return Number.isNaN(parsed) ? null : parsed;
        }

        if (value instanceof Date) {
            return value.getTime();
        }

        return null;
    }

    this.updateLocalStorage = function (keys, itemLists = []) {
        const wishlist = {
            keys: Array.isArray(keys) ? keys : [],
            item_lists: Array.isArray(itemLists) ? itemLists : [],
            last_updated: Date.now(),
            identified: this.canHaveWishlist === true,
        };

        this.wishlist = wishlist;
        this.localStorageManager.set(this.storageKey, wishlist);
        this.syncHeaderCount();
    };

    this.addKeyToLocalStorage = function (key) {
        if (!key) {
            return;
        }

        const existing = this.wishlist && Array.isArray(this.wishlist.keys) ? this.wishlist.keys : [];
        if (existing.includes(key)) {
            return;
        }

        this.updateLocalStorage(
            [...existing, key],
            this.wishlist && Array.isArray(this.wishlist.item_lists) ? this.wishlist.item_lists : [],
        );
    }

    this.removeKeyFromLocalStorage = function (key) {
        if (!key) {
            return;
        }

        const existing = this.wishlist && Array.isArray(this.wishlist.keys) ? this.wishlist.keys : [];
        this.updateLocalStorage(
            existing.filter((wishlistKey) => wishlistKey !== key),
            this.wishlist && Array.isArray(this.wishlist.item_lists) ? this.wishlist.item_lists.filter((item) => item.key !== key) : [],
        );
    }

    this.refreshLocalWishlist = function () {
        $.ajax({
            url: '/wishlist/keys',
            type: 'GET',
            cache: false,
            data: {
                _: Date.now(),
            },
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            },
            success: function (response) {
                if (response && response.payload && Array.isArray(response.payload.keys)) {
                    self.updateLocalStorage(response.payload.keys, response.payload.item_lists || []);
                    self.updateButtons();
                    return;
                }

                self.syncHeaderCount();
            },
        });
    };

    this.refreshStoredWishlist = function () {
        this.localStorageManager.remove(this.storageKey);
        this.wishlist = {keys: [], item_lists: []};
        this.syncHeaderCount();

        if (this.canHaveWishlist) {
            this.refreshLocalWishlist();
            return;
        }

        this.updateButtons();
    };
}

const initialiseWishlist = () => {
    if (window.wishlist) {
        return;
    }

    window.Wishlist = Wishlist;
    window.wishlist = new Wishlist();
    window.wishlist.init();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseWishlist, {once: true});
} else {
    initialiseWishlist();
}
